import {get, writable} from "svelte/store";
import {orderConfigStore} from "../orders/orders-store.js";

/**
 * Region name user to parse time correctly
 * @type {string}
 */
const REGION = 'en-US';

/**
 * Weekday names (keys) in delivery timetable. Used to get previous day for closeNextDay.
 * @type {string[]}
 */
const WEEKDAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

export const deliveryOpenStore = writable({
    isOpen: false,
    nextOpenDate: null,
    nextOpenDateStr: null,
    waitMinutes: null,
});

/**
 * Check if venue is open and update deliveryOpenStore
 */
export function checkOpenState() {

    const orderConfig = get(orderConfigStore);

    if (orderConfig.deliveryTimetable && (orderConfig.scheduleType || 'timetable') === 'timetable') {

        const openState = isOpenNow(orderConfig.deliveryTimetable, orderConfig.deliveryTimetable.timezone);

        log(openState);

        deliveryOpenStore.update(x => {

            x.isOpen = openState.isOpen;
            x.nextOpenDate = openState.nextOpenDate;
            x.nextOpenDateStr = openState.nextOpenDateStr;
            x.waitMinutes = openState.waitMinutes;
            return x;
        });
    }
    else if (orderConfig.scheduleType === '24x7') {

        deliveryOpenStore.update(x => {

            x.isOpen = true;
            x.nextOpenDate = undefined;
            x.nextOpenDateStr = undefined;
            x.waitMinutes = undefined;
            return x;
        });
    }
}

/////////////////////


export function isOpenNow(schedule, venueTimezone = 'Europe/Moscow', currentDate = new Date()) {

    try {

        const venueTime = new Date(currentDate.toLocaleString(REGION, {timeZone: venueTimezone})); // текущее время в часовом поясе заведения
        const dayOfWeek = venueTime.toLocaleString(REGION, {weekday: "long"}).toLowerCase(); // день недели в часовом поясе заведения
        const dayOfWeekIdx = WEEKDAYS.indexOf(dayOfWeek);
        const prevDayOfWeek = dayOfWeekIdx > 0 ? WEEKDAYS[dayOfWeekIdx - 1] : WEEKDAYS[WEEKDAYS.length - 1];
        const currentTime = venueTime.getHours() * 60 + venueTime.getMinutes(); // текущее время в минутах в часовом поясе заведения
        const formattedDate = venueTime.toISOString().split('T')[0]; // дата в формате YYYY-MM-DD в часовом поясе заведения

        // Проверка закрытых дней
        if (schedule.closedDays && schedule.closedDays.includes(formattedDate)) {

            return getClosedResult(schedule, currentDate, venueTimezone);
        }

        // Проверка исключений на сегодня
        if (schedule.exceptions && schedule.exceptions[formattedDate]) {
            const exception = schedule.exceptions[formattedDate];
            const openTime = toMinutes(exception.open);
            const closeTime = toMinutes(exception.close);

            if (currentTime >= openTime && currentTime <= closeTime) {
                log('[1]');
                return {isOpen: true, nextOpenDate: null};
            } else {
                log('[2]');
                return getClosedResult(schedule, currentDate, venueTimezone);
            }
        }

        // Проверка регулярного расписания
        if (schedule.regularHours) {

            const currentDayHours = schedule.regularHours[dayOfWeek];
            const prevDayHours = schedule.regularHours[prevDayOfWeek];

            if (currentDayHours) {
                const openTime = toMinutes(currentDayHours.open);
                let closeTime = toMinutes(currentDayHours.close);

                /// check prev day (if we have currentDayHours)
                if (prevDayHours?.closeNextDay && currentTime >= 0 && currentTime <= toMinutes(prevDayHours.close)) {
                    log('[3]', prevDayHours?.closeNextDay);
                    return {isOpen: true, nextOpenDate: null};
                }

                // Проверка флага перехода через полночь
                if (currentDayHours.closeNextDay) {
                    closeTime += 24 * 60; // прибавляем 24 часа в минутах
                }

                if (currentTime >= openTime && currentTime <= closeTime) {
                    log('[4]');
                    return {isOpen: true, nextOpenDate: null};
                } else {
                    log('[5]');
                    return getClosedResult(schedule, currentDate, venueTimezone);
                }
            }

            /// check prev day (if we DO NOT have currentDayHours)
            if (prevDayHours?.closeNextDay && currentTime >= 0 && currentTime <= toMinutes(prevDayHours.close)) {
                log('[6]');
                return {isOpen: true, nextOpenDate: null};
            }
        }

        log('[7]');
        // Если ни одно условие не выполнено, заведение закрыто
        return getClosedResult(schedule, currentDate, venueTimezone);

    } catch (e) {
        return {isOpen: true, nextOpenDate: null};
    }
}

function getClosedResult (schedule, currentDate, venueTimezone) {

    const nextOpenDate = getNextOpenDate(schedule, currentDate, venueTimezone);
    return {
        isOpen: false,
        nextOpenDate: nextOpenDate,
        nextOpenDateStr: getNextOpenDateStr(nextOpenDate, venueTimezone),
        waitMinutes: getWaitMinutes(nextOpenDate, venueTimezone)
    };
}

/**
 *
 * @param nextOpenDate: Date
 * @param venueTimezone: string
 * @returns {string|null}
 */
function getNextOpenDateStr(nextOpenDate, venueTimezone) {

    if (!nextOpenDate) {
        return null;
    }

    const d = new Date(nextOpenDate);

    return d.toLocaleTimeString('ru-RU', {
        month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit'
    });
}

function getWaitMinutes(nextOpenDate, venueTimezone) {

    if (!nextOpenDate) {
        return null;
    }

    const d = new Date(nextOpenDate);

    const now = nowInVenueTimezone(venueTimezone);
    const min = (d.getTime() - now.getTime())/1000/60;
    return min > 5 ? Math.ceil(min/5)*5 : Math.ceil(min);
}

function nowInVenueTimezone (venueTimezone) {
    return new Date( (new Date()).toLocaleString(REGION, {timeZone: venueTimezone }));
}

// Функция для вычисления времени ближайшего открытия
function getNextOpenDate(schedule, currentDate, venueTimezone) {
    let daysToCheck = 0;
    let now = nowInVenueTimezone(venueTimezone);
    let nextDate = new Date(currentDate);

    while (daysToCheck < 7) {
        nextDate.setDate(currentDate.getDate() + daysToCheck);

        const nextVenueTime = new Date(nextDate.toLocaleString(REGION, { timeZone: venueTimezone }));
        const nextDayOfWeek = nextVenueTime.toLocaleString(REGION, { weekday: "long", timeZone: venueTimezone }).toLowerCase();
        const formattedNextDate = nextVenueTime.toISOString().split('T')[0];

        // Проверка исключений для будущих дней
        if (schedule.exceptions && schedule.exceptions[formattedNextDate]) {

            const closeDate = new Date(`${formattedNextDate}T${schedule.exceptions[formattedNextDate].close}:00`);
            if (closeDate.getTime() < now.getTime()) {
                daysToCheck++;
                continue;
            }

            return new Date(`${formattedNextDate}T${schedule.exceptions[formattedNextDate].open}:00`);
        }

        // Проверка закрытых дней
        if (schedule.closedDays && schedule.closedDays.includes(formattedNextDate)) {
            daysToCheck++;
            continue;
        }

        // Проверка регулярного расписания
        if (schedule.regularHours && schedule.regularHours[nextDayOfWeek]) {
            const nextOpenTime = schedule.regularHours[nextDayOfWeek].open;

            const closeDate = new Date(`${formattedNextDate}T${schedule.regularHours[nextDayOfWeek].close}:00`);
            if (closeDate.getTime() < now.getTime()) {
                daysToCheck++;
                continue;
            }

            return new Date(`${formattedNextDate}T${nextOpenTime}:00`);
        }

        daysToCheck++;
    }

    return null; // Если нет расписания на будущее (на случай ошибки)
}

// Вспомогательная функция для преобразования времени в минуты
function toMinutes(timeStr) {
    const [hours, minutes] = timeStr.split(':').map(Number);
    return hours * 60 + minutes;
}

function log(msg) {
    if (window.DEBUG_TIME) {
        console.log(msg);
    }
}
